import { Icon } from '@iconify/react';

// The details endpoint returns 404 for a missing row *and* for a soft-deleted
// one, so this covers both without pretending to know which.
const VisitorNotFound = ({ onBack }) => (
    <div className="tw-max-w-md tw-mx-auto tw-mt-16 tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-8 tw-text-center">
        <Icon icon="mdi:account-off-outline" className="tw-text-4xl tw-text-gray-300" />
        <h1 className="tw-mb-0 tw-text-sm tw-font-bold tw-text-gray-800 tw-mt-2">Visitor not found</h1>
        <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-1">
            This visitor does not exist, or has been removed.
        </p>
        <button
            onClick={onBack}
            className="tw-mt-4 tw-px-3 tw-py-2 tw-text-xs tw-font-medium tw-text-white tw-bg-sky-600 hover:tw-bg-sky-700 tw-rounded-md"
        >
            Back to Visitors
        </button>
    </div>
);

export default VisitorNotFound;
